import { QueryClient } from '@tanstack/react-query';

/**
 * Client TanStack Query partagé. Le branchement à l'API arrive dans une phase
 * ultérieure ; pour l'instant il fournit le contexte du provider utilisé dans
 * toute l'ossature de l'application.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
